import TokenAnalyzerSearch from "./TokenAnalyzerSearch";

export default TokenAnalyzerSearch;